import clsx from "clsx";

import {
  ManagedCheckboxInput,
  type CheckboxInputProps,
} from "@/components/compounds/forms/CheckboxInput";
import { ColorEnum } from "@/enums";
import { type CommonProps } from "@/types";
import { createId } from "@/utils/helpers";

import styles from "./CheckboxFacet.module.css";

const ref = "checkbox-facet";

interface CheckboxFacetProps extends Partial<CommonProps & CheckboxInputProps> {
  count?: number;
  label: string;
  gaClick?: string;
  gaClickTarget?: string;
  eventGroup?: string;
}

function useCheckboxFacet(props: CheckboxFacetProps) {
  const {
    color = ColorEnum.DARKGREEN,
    count = 0,
    eventGroup,
    gaClick,
    gaClickTarget,
    id = createId(ref),
    name = `${id}_facet`,
    value = "",
  } = props;
  const className = clsx(styles[ref], color && styles[color], props.className);

  return {
    checked: !!props.checked,
    className,
    count,
    disabled: count === 0,
    eventGroup,
    gaClick,
    gaClickTarget,
    id,
    name,
    value,
  };
}

function CheckboxFacet(props: CheckboxFacetProps) {
  const {
    checked,
    className,
    count,
    disabled,
    eventGroup,
    gaClick,
    gaClickTarget,
    id,
    name,
    value,
  } = useCheckboxFacet(props);
  const checkboxProps: CheckboxInputProps = {
    checked,
    children: (
      <div className={styles.label}>
        {props.label}
        <span className={styles.count}>({count})</span>
      </div>
    ),
    className,
    click: gaClick,
    clickTarget: gaClickTarget,
    disabled,
    eventGroup: eventGroup || "Filters",
    id,
    name,
    noBorder: true,
    rounded: true,
    value,
  };

  return <ManagedCheckboxInput {...checkboxProps} />;
}

export default CheckboxFacet;
export { CheckboxFacet, type CheckboxFacetProps };
